function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5286F9"
    },
    d: "M488.727,66.494H256H23.273C10.42,66.494,0,76.914,0,89.767v332.466  c0,12.853,10.42,23.273,23.273,23.273H256h232.727c12.853,0,23.273-10.42,23.273-23.273V89.767  C512,76.914,501.58,66.494,488.727,66.494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB655"
    },
    d: "M273.776,189.773c5.115,5.86,9.57,12.31,13.236,19.242c7.427,14.041,11.655,30.026,11.655,46.986  s-4.228,32.943-11.655,46.986c-3.666,6.932-8.121,13.38-13.236,19.24c-5.264,6.031-11.23,11.427-17.776,16.069  c16.454,11.664,36.523,18.553,58.182,18.553c55.608,0,100.849-45.241,100.849-100.848S369.79,155.152,314.182,155.152  c-21.659,0-41.728,6.886-58.182,18.553C262.544,178.347,268.51,183.744,273.776,189.773z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8143A"
    },
    d: "M287.012,209.016c-3.666-6.934-8.121-13.382-13.236-19.242c-5.267-6.031-11.231-11.425-17.776-16.066  c-16.452-11.667-36.523-18.553-58.182-18.553c-55.608,0-100.848,45.241-100.848,100.848s45.241,100.848,100.848,100.848  c21.659,0,41.73-6.887,58.182-18.553c6.546-4.641,12.51-10.038,17.776-16.067c5.115-5.86,9.57-12.31,13.236-19.24  c7.427-14.043,11.655-30.028,11.655-46.986C298.667,239.041,294.439,223.057,287.012,209.016z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D6DEB"
    },
    d: "M197.818,356.851c-55.608,0-100.848-45.241-100.848-100.848s45.241-100.848,100.848-100.848  c21.659,0,41.728,6.886,58.182,18.553V66.494H23.273C10.42,66.494,0,76.914,0,89.767v332.466c0,12.853,10.42,23.273,23.273,23.273  H256v-107.21C239.546,349.962,219.477,356.851,197.818,356.851z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.03e585f6046fdd79a32ea0e1dc56ca39.svg";
export { ForwardRef as ReactComponent };